// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"numbers-2-1"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M16 19H8V16.976C8 16.6748 8.1357 16.3897 8.36941 16.1999L14.4983 11.2201C15.4484 10.4482 16 9.28925 16 8.06512V8C16 5.79086 14.2091 4 12 4C9.79086 4 8 5.79086 8 8","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const Numbers21Icon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'numbers-2-1',
    ref,
    icon: element,
  },
));

Numbers21Icon.displayName = 'Numbers21Icon';

export default Numbers21Icon;
